import { isObject, isServiceError } from '../isServiceError';
export class SessionTimeoutFilter {
  constructor() {
    this.expiredSessionMessages = ['Session timed out', 'Cookie has expired'];
    this.isRejectedMessage = message => {
      return this.expiredSessionMessages.some(pattern => message.toLowerCase().includes(pattern.toLowerCase()));
    };
  }
  isLoggable(record) {
    const [maybeError] = record.messages;
    if (!(maybeError instanceof Error)) {
      return true;
    }
    const cause = maybeError.cause;
    if (!isServiceError(cause)) {
      return true;
    }
    const {
      error: {
        status,
        responseJSON
      }
    } = cause;
    return !(status === 401 && isObject(responseJSON) && 'message' in responseJSON && typeof responseJSON.message === 'string' && this.isRejectedMessage(responseJSON.message));
  }
}